import setupNavbar from './navbar';
import setupNotifications from './notifications';
import setupTagsInput from './tags-input';

export default () => {
  setupNavbar();
  setupNotifications();
  setupTagsInput();
};
